import { NavLink } from "react-router-dom";
import { BsLayoutSidebar, BsLayoutSidebarReverse } from "react-icons/bs";
import { LuUsers } from "react-icons/lu";
import { PiUserSwitch } from "react-icons/pi";
import { MdOutlineDashboard } from "react-icons/md";
import { TbRobot } from "react-icons/tb";


export default function SidebarUser({ collapsed, setCollapsed, getChatBookmarkData, selectChatBookMark, chatMarkIdInit, pageName, switchToAdmin }) {

  function getActive(path) {
    const currentPath = window.location.hash.replace(/^#/, "");
    return currentPath === path;
  }

  const menu = [
    {
      name: "Overview",
      path: "/assessment/survey",
      isActive: getActive("/assessment/useroverview"),
      icon: <MdOutlineDashboard className="w-5 h-5" />,
    },
    // {
    //   name: "Avira",
    //   path: "/assessment/mychatbot",
    //   isActive: getActive("/assessment/mychatbot"),
    //   icon: <span class="material-symbols-outlined text-[1.5rem]">
    //     auto_awesome
    //   </span>
    // }
  ];
  let chathistoryList =
    getChatBookmarkData && getChatBookmarkData.length > 0
      ? getChatBookmarkData
      : [];

  const chatMenu = [
    { name: "New Chat", chatMarkId: "new" },
    ...chathistoryList.map((ele) => ({ name: ele.question, chatMarkId: ele.id }))
  ];


  return (
    <>
      {/* SIDEBAR */}
      <aside
        className={`
          fixed top-0 left-0 z-50 h-screen bg-[#f9fafb] border-r
          transition-all duration-300 ease-in-out flex flex-col

          ${collapsed ? "md:w-20" : "md:w-64"}
          md:translate-x-0

          w-64
          ${collapsed ? "-translate-x-full" : "translate-x-0"}
        `}
      >
        {/* HEADER */}
        <div className="px-4 py-5 flex items-center justify-between">
          {!collapsed && (
            <img
              src="/img/TalentPlusStrengths_logo.svg"
              alt="logo"
              className="w-32"
            />
          )}

          {/* DESKTOP TOGGLE */}
          <button
            onClick={() => setCollapsed(!collapsed)}
            className="hidden md:flex p-2 rounded-lg hover:bg-gray-200"
          >
            <BsLayoutSidebar className="w-5 h-5" />
          </button>
        </div>

        {/* MENU */}
        <nav className="px-2 space-y-1">
          {menu.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={() => setCollapsed(true)}
              className={({ }) =>
                `group flex items-center gap-3 px-4 py-3 rounded-lg text-base font-medium transition 
              ${item.isActive
                  ? "bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white"
                  : "hover:bg-gray-200 hover:text-black"
                }`
              }
            >
              {item.icon}
              {!collapsed && item.name}
            </NavLink>
          ))}

          {pageName === "/assessment/mychatbot" && !collapsed ?
            chatMenu.map((item, index) => (
              (item && item.name) &&
              <div
                key={index}
                onClick={() => selectChatBookMark(item.chatMarkId)}
                className={`
                group flex items-center px-3 py-2.5 rounded-md cursor-pointer
                transition-colors duration-200
                ${item.chatMarkId === chatMarkIdInit
                    ? "bg-gray-200 text-gray-900"
                    : "text-gray-700 hover:bg-gray-100"
                  }
            `}
              >
                {!collapsed && (
                  <span
                    className="
                  ml-8 text-sm leading-snug
                  truncate
                  group-hover:text-gray-900
                "
                    title={item.name}
                  >
                    {item.name}
                  </span>
                )}
              </div>
            )) : null}
        </nav>

        {/* BOTTOM */}
        <div className="mt-auto px-2 pb-4">
          <div className="border-t my-4" />

          {/* <NavLink
          to="/notifications"
          className="group flex items-center gap-3 px-4 py-3 rounded-lg text-sm
    text-gray-700 hover:bg-gray-100 relative"
        >
          <MdNotifications className="w-5 h-5" />
          {!collapsed && <span>Notification</span>}

          {collapsed && (
            <span className="absolute left-16 bg-black text-white text-xs px-2 py-1 rounded
      opacity-0 group-hover:opacity-100 whitespace-nowrap">
              Notification
            </span>
          )}
        </NavLink> */}

          {false ?
            <>
              <NavLink
                to="/account"
                className="group flex items-center gap-3 px-4 py-3 rounded-lg text-sm
    text-gray-700 hover:bg-gray-100 relative"
              >
                <LuUsers className="w-5 h-5" />
                {!collapsed && <span>Account</span>}

                {collapsed && (
                  <span className="absolute left-16 bg-black text-white text-xs px-2 py-1 rounded
      opacity-0 group-hover:opacity-100 whitespace-nowrap">
                    Account
                  </span>
                )}
              </NavLink>


            </>
            : null}


          {false && <div onClick={() => switchToAdmin()} className="cursor-pointer group flex items-center gap-3 px-4 py-3 mt-2 rounded-lg text-sm bg-gray-200 hover:bg-gray-300 font-medium relative">
            <PiUserSwitch className="w-5 h-5" />
            {!collapsed && <span>Switch to Admin</span>}
            {collapsed && (
              <span className="absolute left-16 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 whitespace-nowrap">Switch to Self</span>
            )}
          </div>}

        </div>
      </aside>

      {/* MOBILE OVERLAY */}
      {!collapsed && (
        <div
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
          onClick={() => setCollapsed(true)}
        />
      )}
    </>
  );
}